import styled from "@emotion/styled";
import Info from "@engineering/icons/info";
var DropdownWrapper = /*#__PURE__*/ styled("div", {
    target: "eisnkt40"
})("display:flex;align-items:center;column-gap:1rem;");
var InfoIcon = /*#__PURE__*/ styled(Info, {
    target: "eisnkt41"
})("fill:", function(param) {
    var theme = param.theme;
    return theme.color.info;
}, ";width:1.6rem;height:1.6rem;vertical-align:middle;cursor:pointer;");
export { DropdownWrapper, InfoIcon };
